import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Produtos",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab
    }
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "sm": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome",
      "label-for": "name"
    }
  }, [_c('VueSelect', {
    ref: "buscarProduto",
    class: {
      hasErrors: _vm.produtoError,
      inputFilled: _vm.produtoFilled
    },
    attrs: {
      "filterable": false,
      "options": _vm.produtosFetched
    },
    on: {
      "input": _vm.setProduto,
      "search": _vm.onSearchProduto
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(_vm._s(option.codigo) + " - " + _vm._s(option.descricao))]), _c('span', [_vm._v(" " + _vm._s(option.custo > 0 ? "R$: ".concat(_vm.numberToReal(option.custo), " - QTD: ").concat(option.quantidade) : "R$: ".concat(_vm.numberToReal(option.preco), " - QTD: ").concat(option.quantidade)) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.descricao,
      callback: function callback($$v) {
        _vm.descricao = $$v;
      },
      expression: "descricao"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Informe o produto pelo nome")])], 2)], 1)], 1), _c('b-col', {
    staticClass: "mt-1"
  }, [_c('b-dropdown', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "id": "dropdown-dropright",
      "dropright": "",
      "variant": "primary",
      "title": "Mudar tipo de filtro"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('FilterOutline', {
          staticClass: "mt-",
          attrs: {
            "size": 20
          }
        })];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    class: _vm.typeFilter === 1 ? 'bg-primary' : '',
    on: {
      "click": function click() {
        _vm.typeFilter = 1;
      }
    }
  }, [_c('p', {
    class: _vm.typeFilter === 1 ? 'text-white' : ''
  }, [_vm._v("Começando com")])]), _c('b-dropdown-item', {
    class: _vm.typeFilter === 2 ? 'bg-primary' : '',
    on: {
      "click": function click() {
        _vm.typeFilter = 2;
      }
    }
  }, [_c('p', {
    class: _vm.typeFilter === 2 ? 'text-white' : ''
  }, [_vm._v("Terminando com")])]), _c('b-dropdown-item', {
    class: _vm.typeFilter === 3 ? 'bg-primary' : '',
    on: {
      "click": function click() {
        _vm.typeFilter = 3;
      }
    }
  }, [_c('p', {
    class: _vm.typeFilter === 3 ? 'text-white' : ''
  }, [_vm._v("Contendo")])])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": _vm.windowWidth > 768 ? 0 : 6
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Quantidade",
      "label-for": "quantidade"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "quantidade",
      "name": "quantidade"
    },
    model: {
      value: _vm.quantidade,
      callback: function callback($$v) {
        _vm.quantidade = $$v;
      },
      expression: "quantidade"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth > 768 ? 0 : 6
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Unitário",
      "label-for": "preco"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "preco",
      "name": "preco"
    },
    model: {
      value: _vm.preco,
      callback: function callback($$v) {
        _vm.preco = $$v;
      },
      expression: "preco"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth > 768 ? 0 : 6
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Desconto",
      "label-for": "desconto"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "desconto",
      "name": "desconto"
    },
    on: {
      "input": _vm.setDesconto
    },
    model: {
      value: _vm.desconto,
      callback: function callback($$v) {
        _vm.desconto = $$v;
      },
      expression: "desconto"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth > 768 ? 0 : 6
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Total R$",
      "label-for": "total"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "total",
      "name": "total"
    },
    model: {
      value: _vm.total,
      callback: function callback($$v) {
        _vm.total = $$v;
      },
      expression: "total"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label-for": "add"
    }
  }, [_c('button', {
    on: {
      "click": function click($event) {
        return _vm.addProduto(_vm.produtoSelected);
      }
    }
  }, [_vm.windowWidth > 768 ? _c('Plus', {
    staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2 mt-9"
  }) : _c('button', {
    staticClass: "btn btn-info btn-hover-dark font-weight-bolder font-size-lg ml-2"
  }, [_vm._v(" Adicionar produto ")])], 1)])], 1)], 1), _c('b-row', [_c('b-col', [_c('TableApp', {
    ref: "nome",
    attrs: {
      "item": "produto",
      "subTitulo": "",
      "data": _vm.produtos,
      "fields": _vm.fields,
      "classFilterColumn": "nome"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'descricao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "descricao"
          },
          slot: "descricao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.descricao) + " ")])])]) : _vm._e(), props.field == 'quantidade' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "quantidade"
          },
          slot: "quantidade"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.quantity, "quantidade")) + " ")])])]) : _vm._e(), props.field == 'preco' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "preco"
          },
          slot: "preco"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.price, "preco")) + " ")])])]) : _vm._e(), props.field == 'desconto' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "desconto"
          },
          slot: "desconto"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.discount, 2)) + " ")]) : _vm._e(), props.field == 'total' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "total"
          },
          slot: "total"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.total, "preco")) + " ")]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.openModalProduto(props.rowData, props.rowData.currentIndex);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), _c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleDeleteProduto(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  }), _vm.modalProdutoIsOpen ? _c('ModalProduto', {
    attrs: {
      "close": _vm.closeModalProduto,
      "changeProduto": _vm.saveEditProduto,
      "produto": _vm.produtoToEdit,
      "open": _vm.modalProdutoIsOpen
    }
  }) : _vm._e()], 1)], 1), _c('b-row', [_c('b-col', [_c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.openNewProduto
    }
  }, [_vm._v(" Adicionar novo Produto ")])])], 1), _c('VariacaoProdutoModal', {
    attrs: {
      "addProduto": _vm.addProdutoVariacao,
      "produto": _vm.produtoSelected
    },
    on: {
      "onAddProduto": _vm.onAddProdutoFromVariacao
    }
  }), _c('LoteProdutoModal', {
    attrs: {
      "addProduto": _vm.addProdutoLote,
      "produto": _vm.produtoSelected,
      "compra": true,
      "atualizarLotes": _vm.atualizarLotes,
      "quantidade": _vm.quantidade,
      "preco": _vm.preco
    },
    on: {
      "onAddProduto": _vm.onAddProdutoFromLote
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };